import React, { PureComponent } from 'react'
import cx from 'classnames'

import s from './DatePicker.scss'

import Input from 'components/form/Input/Input'
import Calendar from 'components/form/Calendar2/Calendar2'


class DatePicker extends PureComponent {

  node = null

  timeout = null

  state = {
    isFocused: false,
    blurOnChange: false,
  }

  componentDidMount() {
    if (!window.location.pathname.includes('marketplace')) {
      this.setState({ blurOnChange: true })
    }
  }

  beforeMaskedValueChange = (newState, oldState, userInput) => {
    let { value } = newState

    value = value.split('.').map((item, index) => {
      if (index === 0) {
        return item.replace(/_/g, 'д')
      }
      if (index === 1) {
        return item.replace(/_/g, 'м')
      }
      if (index === 2) {
        return item.replace(/_/g, 'г')
      }

      return item
    }).join('.')

    return {
      ...newState,
      value,
    }
  }

  setRef = (node) => this.node = node

  render() {
    const { isFocused, blurOnChange } = this.state
    const { valueLink, placeholder, placeholderClassName, from1900 = true, calendarOptions } = this.props

    // const is2010year  = valueLink.value && valueLink.value[6] === '1'
    const is0month    = valueLink.value && valueLink.value[2] === '0'
    const is0day      = valueLink.value && valueLink.value[0] === '0'
    const is30day     = valueLink.value && valueLink.value[0] === '3'
    const is1year     = valueLink.value && valueLink.value[4] === '1'

    const monthValidation = is0month ? '[1-9]' : '[0-2]'
    const dayValidation   = is0day ? '[1-9]' : '[0-9]'
    const day30Validation = '[0-1]'
    // const year2000validation = `${new Date().getFullYear()}`[3] !== '0' ? `[0-${(new Date().getFullYear() + '')[3]}]` : '[0]'

    let formatChars = {
      n: '[0-1]',
      m: monthValidation,

      e: '[0-3]',
      d: is30day ? day30Validation : dayValidation,

      z: from1900 ? '[1-2]' : '[2]',
      y: is1year ? '[9]' : '[0]',
      w: '[0-9]',
      x: '[0-9]',
    }

    const { bottom, right, ...options } = calendarOptions || {}

    return (
      <div
        ref={this.setRef}
        onClick={() => {
          this.node.children[0].children[0].focus()
        }}
      >
        <Input
          valueLink={valueLink}
          placeholder={placeholder}
          placeholderClassName={placeholderClassName}
          formatChars={formatChars}
          mask={'ed.nm.zywx'}
          maskChar="_"
          beforeMaskedValueChange={this.beforeMaskedValueChange}
          onFocus={() => {
            clearTimeout(this.timeout)
            this.setState({ isFocused: true })
          }}
          onBlur={() => {
            this.timeout = setTimeout(() => {
              this.setState({ isFocused: false })
            }, 250)
          }}
        />
        {
          isFocused && (
            <Calendar
              gutter="md"
              className={cx(s.calendar, {
                [s.bottom]: bottom,
                [s.right]: right,
              })}
              {...(options || {})}
              onClick={() => {
                this.node.children[0].children[0].focus()
              }}
              onChange={(date) => {
                valueLink.set(date[0].format('DDMMYYYY'))

                if (blurOnChange) {
                  this.timeout = setTimeout(() => {
                    this.setState({ isFocused: false })
                  }, 250)
                }
              }}
            />
          )
         }
      </div>
    )
  }
}


export default DatePicker
